import styled, { css } from 'styled-components';
import { Text } from '../Text';
import {
	buttonBorderColors,
	ButtonBorderRadius,
	ButtonColors,
	buttonFontSize,
	buttonFontWeight,
	ButtonHeight,
	buttonPadding,
	buttonTextColors,
} from './Button.model';

const StyledButton = styled.button<{
	$color: ButtonColors;
	$height: ButtonHeight;
	$noBorder?: boolean;
	$borderRadius: ButtonBorderRadius;
	$noInvertImage?: boolean;
	$square?: boolean;
	$hover?: boolean;
	$hoverCurrencyColor?: string;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${(props) => (props.$square ? `${props.$height}px` : '100%')};
	height: ${(props) => props.$height}px;
	padding: 0 ${(props) => buttonPadding[props.$height]}px;
	background-color: ${(props) => props.$color};
	font-size: ${(props) => buttonFontSize[props.$height]}px;
	color: ${(props) => buttonTextColors[props.$color]};
	font-weight: ${(props) => buttonFontWeight[props.$height]};
	border-radius: ${(props) => props.$borderRadius}px;
	border: 0;
	cursor: pointer;
	border: ${(props) =>
		props.$noBorder ? 'none' : `1px solid ${buttonBorderColors[props.$color]}`};
	transition:
		background-color 0.3s ease,
		color 0.3s ease,
		border 0.3s ease;

	img,
	.icon {
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	.img-icon {
		transition: background-color 0.3s ease;
	}

	&:not(:disabled):hover {
		background-color: #ffffff;
		color: #000000;
		border: 1px solid #ffffff;

		img,
		.icon {
			filter: ${(props) => (props.$noInvertImage ? 'none' : 'invert(100%)')};
		}

		.img-icon {
			background-color: ${(props) => !props.$noInvertImage && '#000000'};
		}

		${(props) =>
			props.$hoverCurrencyColor &&
			css`
				.currency-icon {
					background-color: #000000;
				}
			`}
	}

	${(props) =>
		props.$hover &&
		`
		background-color: #ffffff;
		color: #000000;
		border: 1px solid #ffffff;
		
		img {
			filter: invert(100%);
		}

		${Text} {
			color: #000000;
		}
	`}

	&:disabled {
		background-color: rgba(255, 255, 255, 0.02);
		color: rgba(255, 255, 255, 0.25);
		border: ${(props) =>
			props.$noBorder ? 'none' : `1px solid rgba(255, 255, 255, 0.05)`};
		cursor: default;

		img {
			opacity: 0.25;
		}

		.img-icon {
			opacity: 0.25;
			background-color: #ffffff;
		}
	}

	&:focus-visible {
		outline: none;
	}
`;

export { StyledButton };
